import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Lock } from 'lucide-react';
import IndividualMessage from './IndividualMessage';
import { Separator } from '../../ui/separator';
import { useOfficeHost } from '../../lib/useOfficeHost';
import RewriteEmailForm from './RewriteEmailForm';
const MessagesEmpty = ({ onGenerateRewrite, isComposeMode = false, }) => {
    const { isOutlook } = useOfficeHost();
    return (_jsxs(_Fragment, { children: [_jsx(IndividualMessage, { message: {
                    role: 'assistant',
                    value: isComposeMode
                        ? 'How can I help you with this email?'
                        : 'How can I help?',
                    id: 'greeting',
                } }), isOutlook && isComposeMode && onGenerateRewrite && (_jsx(RewriteEmailForm, { onGenerate: onGenerateRewrite })), _jsx("div", { className: 'flex flex-col gap-4 mt-6', children: _jsxs("div", { className: 'flex justify-evenly items-center', children: [_jsx(Separator, { className: 'max-w-[100px] bg-border' }), _jsx("div", { className: 'flex items-center bg-background text-foreground rounded-full py-1 px-2 gap-1', children: _jsx(Lock, { className: "size-4" }) }), _jsx(Separator, { className: 'max-w-[100px] bg-border' })] }) })] }));
};
export default MessagesEmpty;
